import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { User, PaginatedResponse, ApiResponse } from '../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private api = inject(ApiService);
    private readonly path = 'users';

    getAll(params?: any): Observable<ApiResponse<User[]>> {
        return this.api.get<ApiResponse<User[]>>('users', params);
    }

    getById(id: string): Observable<ApiResponse<User>> {
        return this.api.get<ApiResponse<User>>(`${this.path}/${id}`);
    }

    /** SuperAdmin: crea usuario global */
    create(data: Partial<User>): Observable<ApiResponse<User>> {
        return this.api.post<ApiResponse<User>>(this.path, data);
    }

    update(id: string, data: Partial<User>): Observable<ApiResponse<User>> {
        return this.api.patch<ApiResponse<User>>(`${this.path}/${id}`, data);
    }

    delete(id: string): Observable<ApiResponse<void>> {
        return this.api.delete<ApiResponse<void>>(`${this.path}/${id}`);
    }

    toggleActive(id: string): Observable<ApiResponse<User>> {
        return this.api.put<ApiResponse<User>>(`${this.path}/${id}/status`, {});
    }

    /**
     * Business Admin: invita/agrega un colaborador al negocio activo con acciones directas.
     * El backend toma el business del header X-Business-Id (inyectado por interceptor).
     */
    invite(data: {
        email: string;
        fullName?: string;
        username?: string;
        password?: string;
        permissions: string[];
    }): Observable<any> {
        return this.api.post<any>(`${this.path}/invite`, data);
    }
    checkEmail(email: string): Observable<{ exists: boolean, user?: any, alreadyInBusiness?: boolean }> {
        return this.api.get<{ exists: boolean, user?: any, alreadyInBusiness?: boolean }>(`${this.path}/check-email/${email}`);
    }
}
